export default __webpack_public_path__ + "static/media/UserGuideAndSupportIcon.d1e9debc.png";